const ConstantsApi = {
  BASE_URL: process.env.REACT_APP_BASE_URL,

  // Dashboard
  GET_DASHBOARD_DATA: "/get_dashboard_data",
  GET_DASHBOARD_DATA_COMPARISON: "/get_dashboard_data_comparison",
  EXPORT_DASHBOARD_EXCEL_DATA: "/export_dashboard_excel_data",
  EXPORT_DASHBOARD_EXCEL_DATA_COMPARISON: "/export_dashboard_excel_data_comparison",

  // Filter
  GET_DATA_FOR_FILTERING: "/get_data_for_filtering",
  GET_PENDING_CHANGE_REQUESTS_COUNT: "/get_pending_change_requests_count",
  GET_PENDING_CHANGE_REQUESTS: "/get_pending_change_requests",

  // Model
  GET_MODEL_DATA: "/get_model_data",
  UPDATE_MODEL_DATA: "/update_model_data",
  MAKE_MODEL_AS_ZERO: "/make_model_as_zero",
  DELETE_MODEL_VERSION: "/delete_model_version",
  FREEZE_MODEL_VERSION: "/freeze_model_version",
  DELETE_MODEL_OPTION_VALUE: "/delete_model_option_value",
  EDIT_MODEL_OPTION_VALUE: "/edit_model_option_value",
  ADD_MODEL_OPTION_VALUE: "/add_model_option_value",
  GET_MODEL_OPTIONS_VALUES: "/get_model_options_values",

  // Terminal
  GET_TERMINAL_DATA: "/get_terminal_data",
  GET_TERMINALS_GEOJSON: "/get_terminals_geojson",
  UPDATE_TERMINAL_DATA: "/update_terminal_data",
  CREATE_TERMINAL_SUBJECTIVE_CHANGE_REQUEST: "/create_terminal_subjective_change_request",
  APPROVE_TERMINAL_SUBJECTIVE_CHANGE_REQUEST: "/approve_terminal_subjective_change_request",
  REJECT_TERMINAL_SUBJECTIVE_CHANGE_REQUEST: "/reject_terminal_subjective_change_request",
  MAKE_TERMINAL_AS_ZERO: "/make_terminal_as_zero",
  DELETE_TERMINAL: "/delete_terminal",

  // User
  GET_USER_DATA: "/get_user_data",
  REFRESH_TOKEN: "/refresh_token",
  GET_ALL_USERS: "/get_all_users",
  UPDATE_USER_DATA: "/update_user_data",
};

export default ConstantsApi;
